<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-icon-wrap">
      <mat-icon>create_new_folder</mat-icon>
    </div>
    <div class="header-text">
      <h2>Create New Project</h2>
      <p>Set up a separate project with its own chapters, teams, and sprints.</p>
    </div>
  </div>

  <div class="dialog-body">
    <div class="error-banner" *ngIf="errorMessage">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <div class="form-group">
      <label for="projectName">Project Name <span class="required">*</span></label>
      <input
        id="projectName"
        type="text"
        class="form-control"
        placeholder="e.g. Phoenix Portal, Mobile App v2"
        [(ngModel)]="projectName"
        (keydown.enter)="onSubmit()"
        maxlength="80"
        autofocus
      />
      <span class="field-hint">Must be at least 2 characters.</span>
    </div>

    <div class="form-group">
      <label for="projectDesc">Description <span class="optional">(optional)</span></label>
      <textarea
        id="projectDesc"
        rows="3"
        class="form-control textarea"
        placeholder="Brief description of the project goals or scope"
        [(ngModel)]="description"
        maxlength="500"
      ></textarea>
    </div>
  </div>

  <div class="dialog-actions">
    <button mat-button type="button" (click)="onCancel()" [disabled]="isSubmitting">
      Cancel
    </button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="onSubmit()"
      [disabled]="!isValid || isSubmitting"
    >
      <mat-icon *ngIf="!isSubmitting">add</mat-icon>
      <span *ngIf="!isSubmitting">Create Project</span>
      <span *ngIf="isSubmitting">Creating...</span>
    </button>
  </div>
</div>
